import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import ItemCard from './BatchScheduleItem';

const GuidedSectionWrapper = styled.div`
  margin-top: ${Spacings.SPACING_0B};
  margin-bottom: ${({ $isHybrid }) =>
    $isHybrid ? `${Spacings.SPACING_10B}` : `${Spacings.SPACING_20B}`};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_14B};
  }
`;

const StyledH3 = styled(H3)`
  font-weight: ${Fonts.HEAVY};
  margin-bottom: ${Spacings.SPACING_6B};
  line-height: ${Spacings.SPACING_7B};
`;

const StyledH5 = styled(H5)`
  margin-bottom: ${Spacings.SPACING_4B};
  line-height: ${Spacings.SPACING_5B};
`;

const GuidedSection = (props) => {
  const {
    goalUID,
    batchGroupUID,
    isHybrid,
    lessonData,
    lastPrimarySourceSection,
    segmentData
  } = props;

  if (!lessonData?.class) return null;

  return (
    <GuidedSectionWrapper $isHybrid={isHybrid}>
      {isHybrid ? (
        <StyledH5>{lessonData.headerText}</StyledH5>
      ) : (
        <StyledH3>{lessonData.headerText}</StyledH3>
      )}
      <ItemCard
        item={lessonData?.class}
        goalUID={goalUID}
        batchGroupUID={batchGroupUID}
        lastPrimarySourceSection={`${lastPrimarySourceSection} - Guided Section`}
        segmentData={segmentData}
      />
    </GuidedSectionWrapper>
  );
};

export default GuidedSection;
